import { AUTH_TOKEN_KEY } from '@/config/app';
import NotFoundError from '@/pages/errors/not-found-error';
import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/(errors)/404')({
  component: NotFoundError,
  beforeLoad: () => {
    const token = localStorage.getItem(AUTH_TOKEN_KEY);

    if (token) {
      throw redirect({ to: '/' });
    }
  },
});
